import React from "react";
import Home from "./pages/Home/Home";
import Board from "./pages/Board/Board";
import Login from "./pages/Login/Login";
import CreateRecipe from "./pages/CreateRecipe";
import Recipe from "./pages/Recipe/Recipe";
import LayoutWithNavigation from "./components/Layout/Layout";
import "./styles/Theme.css";
import "./styles/App.css"; // Import the custom styles
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import AuthProvider from "./hooks/useAuth";
import AllRecipes from "./pages/AllRecipes/AllRecipes";

const App = () => {
  return (
    <div>
      <AuthProvider>
        <Routes>
          <Route
            index
            element={
              <ProtectedRoute>
                <LayoutWithNavigation ChildPage={Home} />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/:boardId"
            element={
              <ProtectedRoute>
                <LayoutWithNavigation ChildPage={Board} />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/:boardId/create/recipe"
            element={
              <ProtectedRoute>
                <CreateRecipe pageView="route" />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/create/recipe"
            element={
              <ProtectedRoute>
                <CreateRecipe pageView="route" />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/recipe/:id"
            element={
              <ProtectedRoute>
                <LayoutWithNavigation ChildPage={Recipe} />
              </ProtectedRoute>
            }
          />
          <Route
            index
            path="/recipes"
            element={
              <ProtectedRoute>
                <LayoutWithNavigation ChildPage={AllRecipes} />
              </ProtectedRoute>
            }
          />

          <Route
            index
            path="/:boardId/recipe/:id"
            element={
              <ProtectedRoute>
                <LayoutWithNavigation ChildPage={Recipe} />
              </ProtectedRoute>
            }
          />

          <Route path="/login" element={<Login />} />
        </Routes>
      </AuthProvider>
    </div>
  );
};
export default App;
